export default class DynamicStatusOption
{
    constructor() {
      this.value = ''
      this.dynamic_status_id = null
    }
}
